import { Fragment, useEffect, useMemo, useState } from "react";
import ComboboxSelector from "../../../components/ComboBoxSelector";
import { Paragraph } from "../../../components/Typography/Paragraph";
import { Label } from "../../../components/Typography/FieldLabel";
import ReadOnlyAnswer from "./ReadOnlyAnswer";
import JurisdictionInput from "./JurisdictionInput";
import {
  Checkboxes,
  Dropdown,
  RadioGroupSingle,
  Section,
  SectionDivider,
  TextArea,
  TextInput,
} from "./DataEntry";
import Tip from "../../../components/Tip";

export default function DarkWebMonitoringInfo({
  create,
  newProject,
  languageOptions,
  project,
  onFieldChange,
  handleSelectedLanguage,
  handleDeselectedLanguage,
  handleMultiDeSelectNew,
  handleClearAllSelections,
  onSelectionChange,
  selectedJurisdictions,
  setSelectedJurisdictions,
  handleSingleSelect,
  handleMultiSelect,
  handleMultiDeSelect,
  field,
  service,
  scope,
  isChecked,
  currentProject,
}) {
  const [selectedJurisdictions1, setSelectedJurisdictions1] = useState([]);
  const [options, setOptions] = useState([]);
  const [data, setData] = useState([]);
  const [opts2, setOpts2] = useState({});

  useEffect(() => {
    if (
      newProject &&
      newProject.services[
        newProject.services.findIndex((el) => el.service === service)
      ]?.opts2
    ) {
      let opts =
        newProject.services[
          newProject.services.findIndex((el) => el.service === service)
        ].opts2;
      setOpts2({ ...opts });
    }
    console.log("createSolicitationFromTemplate Dark Web", opts2);
  }, [newProject]);

  useEffect(() => {
    console.log("Dark Web Monitoring Opts2 changed", opts2);
  }, [opts2]);

  return (
    <div className="mt-8">
      <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
        {create && create == true && (
          <div className=" col-span-full bg-[#f6f8ff] border border-brand-200 rounded p-2 pb-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <Section label="Assumptions" create={create} />
            <Tip colSpan={"full"} noMargin>
              <div className="inline">
                The fields in the assumptions section are required. It is
                extremely important to fill out the Assumptions section to get
                simple, accurate quotes.
                <span className="ml-1 font-medium">
                  We've provided you with some default answers.
                </span>
              </div>
            </Tip>
            <div id="assumption-list" className="col-span-full space-y-10">
              <TextInput
                label="Number of Affected Individuals"
                tooltip={{
                  title: "Affected Individuals",
                  text: "Letting the vendor know how many people were affected will help them determine how many people need monitoring.",
                }}
                service={service}
                field="number_of_affected_individuals"
                defaultValue={newProject.number_of_affected_individuals || null}
                // type="size"
                create={create}
                // opts2={opts2}
                opts2={{ __nonEmpty: true, ...(opts2 || {}) }}
                placeholder=""
                onFieldChange={onFieldChange}
                required
              />
              <TextInput
                label="Number of Years of Monitoring"
                // tooltip={{
                //   title: "Class size",
                //   text: "Letting the vendor know how many people were affected will help them determine how many letters will need to be mailed.",
                // }}
                service={service}
                field="number_of_years_of_monitoring"
                // defaultValue={newProject.number_of_affected_individuals || null}
                // type="size"
                create={create}
                // opts2={opts2}
                opts2={{ __nonEmpty: true, ...(opts2 || {}) }}
                placeholder=""
                onFieldChange={onFieldChange}
                required
              />
            </div>
          </div>
        )}

        {/* <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"> */}
        <div className="sm:col-span-6">
          <h3 className="text-base font-semibold leading-6 text-slate-900">
            Final Details
          </h3>
          {create && (
            <Paragraph>
              Use the below field to provide any additional details about your
              project or bid request that you think might be helpful to the
              vendor.
            </Paragraph>
          )}
          <div className="mt-1">
            {create ? (
              <textarea
                id="additional_details"
                name="additional_details"
                rows={3}
                value={
                  opts2 && opts2.additional_details
                    ? opts2.additional_details
                    : ""
                }
                onChange={(e) => {
                  onFieldChange(
                    "options",
                    //if checked, true, else false
                    e,

                    "additional_details",
                    "dark_web_monitoring",

                    null
                  );
                }}
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-500 focus:ring-brand-500 sm:text-sm"
              />
            ) : (
              <ReadOnlyAnswer
                answer={opts2 && opts2.additional_details}
                type="text"
              />
            )}
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
}
